import { createContext, useContext, useState } from "react";

export const PHONE_DISPLAY = "+34 657 92 27 69";
export const PHONE_TEL = "tel:+34657922769";
export const WA_NUMBER = "34657922769";

export const waLink = (msg = "") =>
  `https://wa.me/${WA_NUMBER}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;

export const TOWNS = [
  { name: "Benidorm", id: "benidorm" },
  { name: "Finestrat", id: "finestrat" },
  { name: "Villajoyosa", id: "villajoyosa" },
  { name: "La Nucía", id: "lanucia" },
  { name: "Polop", id: "polop" },
  { name: "Altea", id: "altea" },
  { name: "Albir", id: "albir" },
  { name: "Alfaz del Pi", id: "alfazdelpi" },
];

const es = {
  nav: {
    home: "Inicio",
    services: "Servicios",
    gallery: "Galería",
    owners: "Propietarios",
    zones: "Zonas",
    contact: "Contacto",
    cta: "Presupuesto gratis",
  },
  beforeAfter: {
    eyebrow: "Antes y después",
    title: "El resultado lo dice todo",
    sub: "Desliza para comparar. Limpieza profunda de sofás, tapicerías y alfombras.",
    sofa: "Sofá y tapicería",
    carpet: "Alfombra",
    before: "Antes",
    after: "Después",
    cta: "Quiero limpiar el mío",
  },
  owners: {
    eyebrow: "Para propietarios",
    title: "¿Apartamento turístico o segunda residencia?",
    sub: "Me encargo de tu propiedad entre huéspedes o mientras estás fuera. Tú recibes fotos del trabajo hecho por WhatsApp.",
    badge: "El más pedido",
    cta: "Consultar por WhatsApp",
    keys: "¿Vives fuera? Trabajo con las llaves y accesos como me indiques, y te envío fotos del antes y el después de cada visita.",
    note: "Tu propiedad, siempre lista",
    packs: [
      {
        name: "Pack Esencial",
        tagline: "Puesta a punto rápida",
        items: ["Revisión de pequeños desperfectos", "Ajuste de puertas y persianas", "Colgado de cuadros y decoración"],
        wa: "Hola, me interesa el Pack Esencial para mi propiedad.",
      },
      {
        name: "Pack Entre Huéspedes",
        tagline: "Listo para la próxima reserva",
        featured: true,
        items: ["Limpieza de sofás y tapicerías", "Limpieza de alfombras", "Pequeños arreglos exprés", "Fotos del resultado por WhatsApp"],
        wa: "Hola, me interesa el Pack Entre Huéspedes para mi apartamento turístico.",
      },
      {
        name: "Pack Tranquilidad",
        tagline: "Mantenimiento mensual",
        items: ["Visita mensual de revisión", "Prioridad en pequeñas urgencias", "Informe con fotos tras cada visita"],
        wa: "Hola, me interesa el Pack Tranquilidad con mantenimiento mensual.",
      },
    ],
  },
  hero: {
    eyebrow: "Marina Baixa · Costa Blanca",
    line1: "Tu manitas",
    line2: "de confianza",
    sub: "¿Tu lista de pendientes no deja de crecer? Montar, colgar, instalar, reparar, limpiar. Tú no tienes tiempo para los pequeños trabajos de casa. Yo me ocupo de todo.",
    badges: ["Rápido", "Profesional", "De confianza"],
    ctaPrimary: "Pide tu presupuesto por WhatsApp",
    ctaSecondary: "Llámanos",
    note: "Más tiempo para lo que realmente importa",
    stamp: "Tu hogar, en buenas manos",
    scroll: "Desliza",
    polaroid: "Marina Baixa, mi casa",
  },
  marquee: [
    "Pequeñas reparaciones",
    "Montaje de muebles",
    "Instalaciones",
    "Iluminación",
    "Pequeña fontanería",
    "Cuadros y estanterías",
    "Puertas y persianas",
    "Limpieza de sofás",
    "Limpieza de alfombras",
    "Asientos de coche",
  ],
  services: {
    eyebrow: "Servicios",
    title: "Yo me ocupo de todo",
    sub: "Una sola persona de confianza para cada pequeño trabajo. Sin buscar un profesional distinto cada vez.",
    cta: "Pedir presupuesto",
    items: [
      { title: "Pequeñas reparaciones", desc: "Esos desperfectos que van apareciendo en casa, resueltos con cuidado y diligencia.", wa: "Hola, necesito ayuda con una pequeña reparación en casa." },
      { title: "Montaje de muebles", desc: "Armarios, camas, estanterías y más, montados sin estrés y sin instrucciones imposibles.", wa: "Hola, necesito montar un mueble." },
      { title: "Instalación de TV y lámparas", desc: "Televisores en la pared y lámparas colgadas, niveladas y seguras.", wa: "Hola, quiero instalar una televisión o una lámpara." },
      { title: "Pequeña fontanería", desc: "Cambio de grifos, sifones y pequeñas fugas, sin obras ni complicaciones.", wa: "Hola, tengo un pequeño trabajo de fontanería." },
      { title: "Cuadros, espejos y estanterías", desc: "Todo colgado recto, a la primera y sin agujeros de más.", wa: "Hola, quiero colgar cuadros, espejos o estanterías." },
      { title: "Puertas y persianas", desc: "Ajusto puertas que rozan y reparo persianas atascadas o rotas.", wa: "Hola, necesito ajustar una puerta o reparar una persiana." },
      { title: "Limpieza de sofás y tapicerías", desc: "Devuelve la vida a tus sofás con una limpieza profunda de tapicerías.", wa: "Hola, quiero limpiar un sofá o una tapicería." },
      { title: "Limpieza de alfombras", desc: "Alfombras como nuevas, sin olores ni manchas.", wa: "Hola, quiero limpiar una alfombra." },
      { title: "Limpieza de asientos de coche", desc: "La tapicería de tu coche impecable, como recién salido del concesionario.", wa: "Hola, quiero limpiar los asientos de mi coche." },
      { title: "Servicio exprés", desc: "Pequeñas urgencias que no pueden esperar, atendidas con rapidez.", wa: "Hola, tengo una pequeña urgencia en casa." },
    ],
  },
  manifesto: {
    eyebrow: "Manifiesto",
    title: "Trato tu hogar como si fuera el mío",
    chapters: [
      { title: "Sin intermediarios", desc: "Hablas directamente conmigo, la persona que hará el trabajo. Nada de centralitas ni presupuestos que se pierden." },
      { title: "Presupuesto con una foto", desc: "Envíame una foto o un vídeo por WhatsApp y cuéntame qué necesitas. Te respondo rápidamente con un precio claro." },
      { title: "Puntual y limpio", desc: "Llego a la hora acordada, trabajo con cuidado y dejo todo recogido. Como debe ser." },
      { title: "Cercano y de confianza", desc: "Un servicio práctico y cercano en Marina Baixa: para tu casa, tu segunda residencia o tu apartamento turístico." },
    ],
    note: "Tú disfrutas de tu tiempo. Yo me ocupo de la lista.",
  },
  gallery: {
    eyebrow: "Galería",
    title: "Trabajos reales, resultados reales",
    sub: "Una muestra de lo que hago cada día en los hogares de la Marina Baixa.",
    filters: ["Todo", "Reparaciones", "Instalaciones", "Limpieza"],
  },
  steps: {
    eyebrow: "Cómo funciona",
    title: "Tu presupuesto en 3 pasos",
    items: [
      { title: "Haz una foto o vídeo", desc: "Enseña el trabajo o el desperfecto tal cual es. Sin vueltas." },
      { title: "Envíalo por WhatsApp", desc: "Al +34 657 92 27 69, y cuéntame qué necesitas." },
      { title: "Recibe tu presupuesto", desc: "Te respondo rápido con precio claro y fecha de visita." },
    ],
  },
  zones: {
    eyebrow: "Zonas",
    title: "Servicio en toda la Marina Baixa",
    sub: "Benidorm · Finestrat · Villajoyosa · La Nucía · Polop · Altea · Albir · Alfaz del Pi y alrededores.",
    cta: "Consulta tu zona por WhatsApp",
    note: "Hogares más felices en la Costa Blanca",
    waTown: (town) => `Hola, vivo en ${town} y necesito un manitas de confianza.`,
  },
  testimonials: {
    eyebrow: "Reseñas",
    title: "Lo que dicen los vecinos",
    sub: "La confianza se gana trabajo a trabajo, pueblo a pueblo.",
    items: [
      { quote: "Me montó dos armarios y colgó todas las estanterías en una mañana. Puntual, limpio y muy agradable de tratar.", name: "Mª Carmen R.", town: "Benidorm" },
      { quote: "Le envié una foto del sofá por WhatsApp y quedó como nuevo. Mi apartamento turístico siempre listo entre huéspedes.", name: "John W.", town: "Altea" },
      { quote: "Me reparó la persiana y ajustó la puerta del baño en la misma visita. Precio cerrado y sin sorpresas.", name: "Lucía G.", town: "La Nucía" },
    ],
  },
  faq: {
    eyebrow: "Preguntas frecuentes",
    title: "¿Tienes dudas? Te las resuelvo",
    sub: "Y si no encuentras tu respuesta, escríbeme por WhatsApp sin compromiso.",
    cta: "Preguntar por WhatsApp",
    items: [
      { q: "¿Cuál es tu horario?", a: "De lunes a sábado, con flexibilidad para adaptarme a ti. Si es una pequeña urgencia, escríbeme por WhatsApp y vemos si puedo pasar antes." },
      { q: "¿Cobras desplazamiento?", a: "No cobro desplazamiento dentro de la Marina Baixa: Benidorm, Finestrat, Villajoyosa, La Nucía, Polop, Altea, Albir y Alfaz del Pi. Si estás un poco más lejos, consúltame." },
      { q: "¿El presupuesto es gratis?", a: "Sí, totalmente. Envíame una foto o un vídeo del trabajo por WhatsApp y te doy un precio claro y cerrado, sin compromiso." },
      { q: "¿Tengo que comprar yo los materiales?", a: "No hace falta: puedo traer las herramientas y los materiales básicos. Y si prefieres comprar tú algo concreto, sin problema." },
      { q: "¿El trabajo tiene garantía?", a: "Sí. Trabajo con cuidado y, si algo no queda bien, vuelvo y lo repaso sin coste. Tu tranquilidad es lo primero." },
      { q: "¿Cómo se paga?", a: "Al terminar el trabajo: efectivo, tarjeta, Bizum o transferencia. Para los packs de propietarios, después de cada visita o mensualmente, como prefieras.", pay: { cash: "Efectivo", transfer: "Transferencia" } },
    ],
  },
  footer: {
    title: "¿Tienes algo que reparar o limpiar?",
    sub: "Envíanos una foto o cuéntanos qué necesitas. Te respondemos rápidamente.",
    cta: "Contacta por WhatsApp",
    script: "Pequeños trabajos, grandes soluciones",
    fix: "We fix it. We clean it.",
    area: "Marina Baixa, Costa Blanca",
    rights: "© 2026 CasaFix Marina · Tu manitas de confianza",
    hands: "Tu hogar, en buenas manos",
  },
  chat: {
    title: "Asistente CasaFix",
    subtitle: "Respuestas al momento, con IA",
    greeting: "¡Hola! Soy el asistente de CasaFix Marina. Pregúntame por servicios, zonas, precios o cómo pedir presupuesto.",
    placeholder: "Escribe tu pregunta...",
    chips: ["¿Cuánto cuesta?", "¿Qué zonas cubres?", "¿Cómo pido presupuesto?"],
    whatsapp: "Pedir presupuesto por WhatsApp",
    error: "Ups, algo ha fallado. Escríbeme por WhatsApp al +34 657 92 27 69.",
  },
  payLabels: { cash: "Efectivo", transfer: "Transferencia" },
  floating: "Escríbeme",
  waGeneric: "Hola, necesito un manitas de confianza. Te envío una foto de lo que necesito.",
  hours: {
    schedule: "Lunes a Sábado 8:00–20:00",
    sundays: "Domingos y festivos solo urgencias",
    openNow: "Abierto ahora",
    closedNow: "Cerrado · solo urgencias",
    sameDay: "Urgencias el mismo día",
    barCta: "Escríbeme",
    title: "¿Una urgencia? Te atiendo hoy",
    sub: "Persiana atascada, cerradura que no cierra, fuga pequeña… Escríbeme por WhatsApp y, si es urgente, intento pasar el mismo día.",
    scheduleLabel: "Horario habitual",
    urgentLabel: "Urgencias",
    urgentValue: "7 días · mismo día si es posible",
    cta: "Tengo una urgencia",
    waUrgent: "Hola, tengo una URGENCIA y necesito que vengas hoy si es posible. Te cuento:",
  },
  estimate: {
    open: "Presupuesto rápido",
    eyebrow: "Calculadora orientativa",
    title: "¿Qué necesitas?",
    sub: "Marca los servicios y te doy una horquilla orientativa al instante. El precio cerrado te lo confirmo por WhatsApp con una foto.",
    consult: "Consultar",
    empty: "Selecciona al menos un servicio",
    selected: "servicios seleccionados",
    total: "Estimación orientativa",
    from: "Desde",
    to: "hasta",
    note: "Precios orientativos, IVA aparte. Puede variar según el trabajo. Sin compromiso.",
    cta: "Pedir presupuesto por WhatsApp",
    clear: "Limpiar",
    waIntro: "Hola, me gustaría un presupuesto para:",
    waEstimate: "Estimación orientativa web",
    waConsult: "a consultar",
    services: {
      repairs: "Pequeñas reparaciones (bisagra, grifo, cisterna, enchufe)",
      furniture: "Montaje de muebles",
      tv: "Colgar TV en la pared",
      lighting: "Lámparas e iluminación",
      pictures: "Cuadros, espejos y estanterías",
      doors: "Puertas, persianas y cerraduras",
      sofa: "Limpieza de sofá",
      carpet: "Limpieza de alfombra",
      car: "Limpieza de asientos de coche",
      pack: "Pack mantenimiento apartamento turístico",
    },
  },
};

const en = {
  nav: {
    home: "Home",
    services: "Services",
    gallery: "Gallery",
    owners: "Owners",
    zones: "Areas",
    contact: "Contact",
    cta: "Free quote",
  },
  beforeAfter: {
    eyebrow: "Before & after",
    title: "The result says it all",
    sub: "Drag to compare. Deep cleaning of sofas, upholstery and carpets.",
    sofa: "Sofa & upholstery",
    carpet: "Carpet",
    before: "Before",
    after: "After",
    cta: "I want mine cleaned",
  },
  owners: {
    eyebrow: "For owners",
    title: "Holiday apartment or second home?",
    sub: "I look after your property between guests or while you're away. You receive photos of the finished work on WhatsApp.",
    badge: "Most popular",
    cta: "Ask on WhatsApp",
    keys: "Live abroad? I work with keys and access exactly as you instruct, and send you before/after photos of every visit.",
    note: "Your property, always ready",
    packs: [
      {
        name: "Essential Pack",
        tagline: "Quick tune-up",
        items: ["Small defects check", "Door & blind adjustments", "Hanging pictures & decor"],
        wa: "Hi, I'm interested in the Essential Pack for my property.",
      },
      {
        name: "Between Guests Pack",
        tagline: "Ready for the next booking",
        featured: true,
        items: ["Sofa & upholstery cleaning", "Carpet cleaning", "Quick express fixes", "Result photos on WhatsApp"],
        wa: "Hi, I'm interested in the Between Guests Pack for my holiday apartment.",
      },
      {
        name: "Peace of Mind Pack",
        tagline: "Monthly maintenance",
        items: ["Monthly check-up visit", "Priority for small urgent jobs", "Photo report after each visit"],
        wa: "Hi, I'm interested in the Peace of Mind Pack with monthly maintenance.",
      },
    ],
  },
  hero: {
    eyebrow: "Marina Baixa · Costa Blanca",
    line1: "Your trusted",
    line2: "handyman",
    sub: "Is your to-do list never-ending? Assembling, hanging, installing, repairing, cleaning. You don't have time for the little jobs around the house. I take care of everything.",
    badges: ["Fast", "Professional", "Trustworthy"],
    ctaPrimary: "Get your quote on WhatsApp",
    ctaSecondary: "Call us",
    note: "More time for what really matters",
    stamp: "Your home, in good hands",
    scroll: "Scroll",
    polaroid: "Marina Baixa, my home",
  },
  marquee: [
    "Small repairs",
    "Furniture assembly",
    "Installations",
    "Lighting",
    "Small plumbing",
    "Pictures & shelves",
    "Doors & blinds",
    "Sofa cleaning",
    "Carpet cleaning",
    "Car seats",
  ],
  services: {
    eyebrow: "Services",
    title: "I take care of everything",
    sub: "One trusted person for every small job. No more searching for a different professional each time.",
    cta: "Get a quote",
    items: [
      { title: "Small home repairs", desc: "Those little faults that keep appearing at home, fixed with care and diligence.", wa: "Hi, I need help with a small home repair." },
      { title: "Furniture assembly", desc: "Wardrobes, beds, shelves and more, assembled without stress or impossible manuals.", wa: "Hi, I need help assembling furniture." },
      { title: "TV & lamp installation", desc: "TVs wall-mounted and lamps hung, level and secure.", wa: "Hi, I'd like to install a TV or a lamp." },
      { title: "Small plumbing", desc: "Tap replacements, traps and small leaks, without building work or hassle.", wa: "Hi, I have a small plumbing job." },
      { title: "Pictures, mirrors & shelves", desc: "Everything hung straight, first time, with no extra holes.", wa: "Hi, I want to hang pictures, mirrors or shelves." },
      { title: "Doors & blinds", desc: "I adjust sticking doors and repair jammed or broken blinds.", wa: "Hi, I need a door adjusted or a blind repaired." },
      { title: "Sofa & upholstery cleaning", desc: "Bring your sofas back to life with a deep upholstery clean.", wa: "Hi, I'd like a sofa or upholstery cleaned." },
      { title: "Carpet cleaning", desc: "Carpets like new, free of odours and stains.", wa: "Hi, I'd like a carpet cleaned." },
      { title: "Car seat cleaning", desc: "Your car upholstery spotless, like it just left the dealership.", wa: "Hi, I'd like my car seats cleaned." },
      { title: "Express service", desc: "Small urgent jobs that can't wait, handled fast.", wa: "Hi, I have a small urgent job at home." },
    ],
  },
  manifesto: {
    eyebrow: "Manifesto",
    title: "I treat your home as if it were my own",
    chapters: [
      { title: "No middlemen", desc: "You speak directly with me, the person who will do the work. No call centres, no lost quotes." },
      { title: "Quote from a photo", desc: "Send me a photo or video on WhatsApp and tell me what you need. I'll reply quickly with a clear price." },
      { title: "Punctual & tidy", desc: "I arrive at the agreed time, work with care and leave everything spotless. As it should be." },
      { title: "Local & trusted", desc: "A practical, friendly service across Marina Baixa: for your home, your second residence or your holiday apartment." },
    ],
    note: "You enjoy your time. I take care of the list.",
  },
  gallery: {
    eyebrow: "Gallery",
    title: "Real work, real results",
    sub: "A glimpse of what I do every day in homes across the Marina Baixa.",
    filters: ["All", "Repairs", "Installations", "Cleaning"],
  },
  steps: {
    eyebrow: "How it works",
    title: "Your quote in 3 steps",
    items: [
      { title: "Take a photo or video", desc: "Show the job or the fault exactly as it is. No fuss." },
      { title: "Send it on WhatsApp", desc: "To +34 657 92 27 69, and tell me what you need." },
      { title: "Get your quote", desc: "I reply fast with a clear price and a visit date." },
    ],
  },
  zones: {
    eyebrow: "Areas",
    title: "Serving the whole Marina Baixa",
    sub: "Benidorm · Finestrat · Villajoyosa · La Nucía · Polop · Altea · Albir · Alfaz del Pi and surroundings.",
    cta: "Ask about your area on WhatsApp",
    note: "Happier homes on the Costa Blanca",
    waTown: (town) => `Hi, I live in ${town} and I need a trusted handyman.`,
  },
  testimonials: {
    eyebrow: "Reviews",
    title: "What the neighbours say",
    sub: "Trust is earned job by job, town by town.",
    items: [
      { quote: "He assembled two wardrobes and hung all the shelves in one morning. Punctual, tidy and lovely to deal with.", name: "Mª Carmen R.", town: "Benidorm" },
      { quote: "I sent him a photo of the sofa on WhatsApp and it came back like new. My holiday apartment is always guest-ready.", name: "John W.", town: "Altea" },
      { quote: "He fixed the blind and adjusted the bathroom door in the same visit. Fixed price, no surprises.", name: "Lucía G.", town: "La Nucía" },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Questions? I've got answers",
    sub: "And if you can't find yours, message me on WhatsApp — no strings attached.",
    cta: "Ask on WhatsApp",
    items: [
      { q: "What are your working hours?", a: "Monday to Saturday, flexible to fit around you. For small urgent jobs, message me on WhatsApp and I'll see if I can come sooner." },
      { q: "Do you charge for travel?", a: "No travel charge within the Marina Baixa: Benidorm, Finestrat, Villajoyosa, La Nucía, Polop, Altea, Albir and Alfaz del Pi. A bit further out? Just ask." },
      { q: "Is the quote free?", a: "Yes, completely. Send me a photo or video of the job on WhatsApp and I'll give you a clear, fixed price with no obligation." },
      { q: "Do I need to buy the materials?", a: "No need: I can bring the tools and basic materials. And if you'd rather buy something specific yourself, that's fine too." },
      { q: "Is the work guaranteed?", a: "Yes. I work with care, and if something isn't right I'll come back and make it right at no cost. Your peace of mind comes first." },
      { q: "How do I pay?", a: "When the job is done: cash, card, Bizum or bank transfer. For owner packs, after each visit or monthly — whichever suits you.", pay: { cash: "Cash", transfer: "Bank transfer" } },
    ],
  },
  footer: {
    title: "Something to fix or clean?",
    sub: "Send us a photo or tell us what you need. We reply quickly.",
    cta: "Chat on WhatsApp",
    script: "Small jobs, big solutions",
    fix: "We fix it. We clean it.",
    area: "Marina Baixa, Costa Blanca",
    rights: "© 2026 CasaFix Marina · Your trusted handyman",
    hands: "Your home, in good hands",
  },
  chat: {
    title: "CasaFix Assistant",
    subtitle: "Instant answers, powered by AI",
    greeting: "Hi! I'm the CasaFix Marina assistant. Ask me about services, areas, prices or how to get a quote.",
    placeholder: "Type your question...",
    chips: ["How much does it cost?", "Which areas do you cover?", "How do I get a quote?"],
    whatsapp: "Get a quote on WhatsApp",
    error: "Oops, something went wrong. Message me on WhatsApp at +34 657 92 27 69.",
  },
  payLabels: { cash: "Cash", transfer: "Bank transfer" },
  floating: "Message me",
  waGeneric: "Hi, I need a trusted handyman. I'm sending you a photo of what I need.",
  hours: {
    schedule: "Monday to Saturday 8:00–20:00",
    sundays: "Sundays & holidays: emergencies only",
    openNow: "Open now",
    closedNow: "Closed · emergencies only",
    sameDay: "Same-day emergencies",
    barCta: "Message me",
    title: "An emergency? I'll come today",
    sub: "Stuck blind, lock that won't close, small leak… Message me on WhatsApp and, if it's urgent, I'll try to come the same day.",
    scheduleLabel: "Regular hours",
    urgentLabel: "Emergencies",
    urgentValue: "7 days · same day when possible",
    cta: "I have an emergency",
    waUrgent: "Hi, I have an EMERGENCY and need you today if possible. Here's the issue:",
  },
  estimate: {
    open: "Quick estimate",
    eyebrow: "Indicative calculator",
    title: "What do you need?",
    sub: "Tick the services and get an indicative price range instantly. I'll confirm a fixed price on WhatsApp from a photo.",
    consult: "On request",
    empty: "Select at least one service",
    selected: "services selected",
    total: "Indicative estimate",
    from: "From",
    to: "to",
    note: "Indicative prices, VAT not included. May vary depending on the job. No obligation.",
    cta: "Request a quote on WhatsApp",
    clear: "Clear",
    waIntro: "Hi, I'd like a quote for:",
    waEstimate: "Website indicative estimate",
    waConsult: "on request",
    services: {
      repairs: "Small repairs (hinge, tap, cistern, socket)",
      furniture: "Furniture assembly",
      tv: "Wall-mounted TV",
      lighting: "Lamps & lighting",
      pictures: "Pictures, mirrors & shelves",
      doors: "Doors, blinds & locks",
      sofa: "Sofa cleaning",
      carpet: "Carpet cleaning",
      car: "Car seat cleaning",
      pack: "Holiday apartment maintenance pack",
    },
  },
};

const translations = { es, en };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
